export const en = {
    'toggle-button-text-show': 'Show full',
    'toggle-button-text-hide': 'Hide',
}
